module.exports = {
  PREDES_TRANSACTIONS_REJECT_REQUEST: 'PREDES_TRANSACTIONS_REJECT_REQUEST',
  PREDES_TRANSACTIONS_REJECT_SUCCESS: 'PREDES_TRANSACTIONS_REJECT_SUCCESS',
  PREDES_TRANSACTIONS_REJECT_FAILURE: 'PREDES_TRANSACTIONS_REJECT_FAILURE',
  PREDES_TRANSACTIONS_BULK_REJECT_REQUEST: 'PREDES_TRANSACTIONS_BULK_REJECT_REQUEST',
  PREDES_TRANSACTIONS_BULK_REJECT_SUCCESS: 'PREDES_TRANSACTIONS_BULK_REJECT_SUCCESS',
  PREDES_TRANSACTIONS_BULK_REJECT_FAILURE: 'PREDES_TRANSACTIONS_BULK_REJECT_FAILURE',
};
